function initBundleSwiper() {
  const swiperEl = document.querySelector('.model-swiper');
  
  if (swiperEl) {
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    new Swiper('.model-swiper', {
      slidesPerView: 2.2, 
      spaceBetween: 12,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1025: {
          slidesPerView: 2,
          spaceBetween: 16,
          allowTouchMove: true
        }
      }
    });
  }
}

if (document.readyState === 'complete') {
  initBundleSwiper();
} else {
  document.addEventListener('DOMContentLoaded', initBundleSwiper);
}

document.addEventListener('shopify:section:load', initBundleSwiper);

function updateUpsellVariant(selectElement) {

  const parentItem = selectElement.closest('.upsell-v-item');
  if (!parentItem) return;


  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const newVariantId = selectedOption.value;
  const newPriceRaw = selectedOption.getAttribute('data-price');
  const newImg = selectedOption.getAttribute('data-img');
  const imgTag = parentItem.querySelector('.upsell-v-img-box img');
  if (imgTag && newImg) {
    imgTag.src = newImg;
  }

  parentItem.setAttribute('data-price-raw', newPriceRaw);
  const priceDisplay = parentItem.querySelector('.upsell-v-price');
  if (priceDisplay) {
    let formattedPrice = (newPriceRaw / 100).toFixed(2);
    formattedPrice = formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    priceDisplay.innerText = '+' + (window.Shopify?.currency?.active || 'HK$') + formattedPrice;
  }

  if (parentItem.classList.contains('is-active')) {
  if (typeof toggleUpsellPricePatch === 'function') {
      refreshAppleTotalRoller(); 
    }
  }
}

function refreshAppleTotalRoller() {
  const allActive = document.querySelectorAll('.ap-apple-tile.is-active, .upsell-v-item.is-active, .ap-upsell-addon-item.is-active');
  let totalRaw = 0;
  
  allActive.forEach(item => {
    totalRaw += parseInt(item.getAttribute('data-price-raw') || 0);
  });

  const roller = document.querySelector('.a-price-current');
  if (roller) {
    let finalPrice = (totalRaw / 100).toFixed(2);
    finalPrice = finalPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    roller.innerText = (window.Shopify?.currency?.active || 'HK$') + finalPrice;
  }
}